import api from './api';

// gym-api responses are enveloped as { success, message, data, error } —
// this helper unwraps to the `data` payload for callers.

export async function getMyGymBookings(params = {}) {
  const res = await api.get('/gyms/me/bookings', { params });
  return res.data.data;
}

export async function getMyGymBookingCalendar(from, to) {
  const res = await api.get('/gyms/me/bookings/calendar', { params: { from, to } });
  return res.data.data;
}
